import classNames from 'classnames'
import { endOfMonth, startOfMonth } from 'date-fns'
import { type Quote } from 'finviz-charts/server/offScreenCanvasRender'

import { getDate } from '../../../../../app/header/utils'
import { RedGreenText } from '../../../../components/RedGreenText'
import { shortFormatDollar } from '../../../../util'
import { BarType } from './constants'
import { ChartBaseData, VolumeChartDataPerTimeframe } from './types'

/**
 * Only get data between from/to range
 */
export function filterDataForChart(quote: Quote, [fromDate, toDate]: number[]) {
  const monthlyData: ChartBaseData[] = []

  const fromTimestamp = getDate(startOfMonth(getDate(fromDate))).getTime()
  const toTimestamp = getDate(endOfMonth(getDate(toDate))).getTime()
  for (let index = 0; index < quote.date.length; index++) {
    const currentTimestamp = quote.date[index] * 1000
    const currentClose = quote.close[quote.barToDataIndex[index]]

    if (fromTimestamp > currentTimestamp || currentTimestamp > toTimestamp) continue

    monthlyData.push({ date: currentTimestamp, close: currentClose })
  }

  return monthlyData
}

export function tooltipTitleFormatter(date: number) {
  const startDate = startOfMonth(date)
  const endDate = endOfMonth(startDate)

  const month = startDate.toLocaleString('en-US', { month: 'short' })
  const startDay = startDate.getDate()
  const year = startDate.getFullYear()
  const endDay = endDate.getDate()
  return `${month} ${startDay}-${endDay}, ${year}`
}

export function tooltipDataFormatter(
  _: unknown,
  {
    dataKey,
    fullTooltipPayload,
  }: { dataKey: string; fullTooltipPayload: { payload?: { insider: VolumeChartDataPerTimeframe } }[] }
) {
  const { insider } = fullTooltipPayload[0]?.payload ?? {}

  if (!insider) return null

  const tradeCount = dataKey === BarType.Buy ? insider?.buyTransactionCount : insider?.saleTransactionCount
  const value = dataKey === BarType.Buy ? insider?.buyAggregated : insider?.saleAggregated
  const isZeroValue = value === 0
  const valueToUse = isZeroValue ? null : dataKey === BarType.Buy ? value : -value

  return (
    <RedGreenText
      // use null to get gray color on zero values
      value={valueToUse}
      rightContent={null}
      className={classNames('col-end-3 grid grid-cols-subgrid', {
        'col-start-3': isZeroValue,
        'col-start-1': !isZeroValue,
      })}
    >
      <span className="ml-1">{shortFormatDollar(isZeroValue ? null : value, { defaultValue: '—' })} </span>
      {!isZeroValue && (
        <span className="ml-1 text-left">
          ({tradeCount ?? 0} Trade{tradeCount === 1 ? '' : 's'})
        </span>
      )}
    </RedGreenText>
  )
}
